import CardHeader from '@/common/components/Card/CardHeader'
import { Button, Card, Typography } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { CampaignVideoQuizResults } from '@/api/campaigns/campagin-quiz-results'
import { useEducationModuleById } from '@/api/education-modules/module-by-id'
import { NoInteractions, NoQuizAvailable } from './EmptyStates'
import QuizResults from './QuizResults'

type CampaignQuizResultsParams = {
  videoId: string
  quizResults: CampaignVideoQuizResults
  hasQuizzes: boolean
}

const VideoQuizResults: FC<CampaignQuizResultsParams> = ({ videoId, quizResults, hasQuizzes }) => {
  const { t } = useTranslation()
  const { data: video } = useEducationModuleById(videoId)

  const score = quizResults?.length ? quizResults.reduce((sum, { score }) => sum + score, 0) / quizResults.length : 0

  const videoHasQuizzes =
    hasQuizzes && ((video?.number_of_quiz_questions ?? 0) > 0 || (video?.quizzes?.length ?? 0) > 0)

  return (
    <Card>
      <CardHeader title={t('campaignDashboard.campaignQuizResults.title')}>
        {videoHasQuizzes && (
          <Button
            variant="outlined"
            size="small"
            onClick={() => window.open(`/content/quiz/preview/${video?.quizzes?.[0]?._id}`, '_blank')}>
            {t('campaignDashboard.campaignQuizResults.viewQuiz')}
          </Button>
        )}
      </CardHeader>
      <Typography fontSize={12} paddingTop={1}>
        {t('campaignDashboard.campaignQuizResults.subTitle')}
      </Typography>

      {!videoHasQuizzes ? (
        <NoQuizAvailable />
      ) : score < 0 ? (
        <NoInteractions />
      ) : (
        <QuizResults quizResults={quizResults} score={score} />
      )}
    </Card>
  )
}

export default VideoQuizResults
